module.exports = __webpack_public_path__ + "img/building95-2.91d68804.jpg";